export const STATE_NAME = "pendingRequests";
